var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencilBigStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 18,
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M26.41 9.612a1.974 1.974 0 0 0 .002-2.814l-5.268-5.215a2.026 2.026 0 0 0-2.842-.002L3.552 16.144c-.394.39-.672.88-.802 1.416l-1.693 6.985c-.36 1.485 1.037 2.801 2.519 2.373l6.761-1.953c.485-.14.927-.4 1.285-.753zm-5.946 3.06L10.202 22.806c-.12.117-.267.204-.428.25l-5.603 1.62a.7.7 0 0 1-.875-.838l1.409-5.813a1 1 0 0 1 .267-.472L15.195 7.459zm1.423-1.404-5.269-5.214 2.4-2.37a1 1 0 0 1 1.407 0l3.846 3.809a1 1 0 0 1-.001 1.422z",
  clipRule: "evenodd"
})));
export default SvgPencilBigStroke;